export function isPositionWithinDOMRect({ x, y }: { x: number; y: number }, { top, left, right, bottom }: DOMRect) {
  return x >= left && x <= right && y >= top && y <= bottom;
}
